var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 507,
    height: 481,
    viewBox: "0 0 507 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3233_1084)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M469.938 2.75586H35.769C16.898 2.75586 1.6001 18.0538 1.6001 36.9247V444.143C1.6001 463.013 16.898 478.311 35.769 478.311H469.938C488.809 478.311 504.107 463.013 504.107 444.143V36.9247C504.107 18.0538 488.809 2.75586 469.938 2.75586Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M390.267 3H36.2045C27.139 3 18.4444 6.59881 12.0308 13.0057C5.61726 19.4126 2.00942 28.1035 2 37.1689V444.351C2.00942 453.417 5.61726 462.107 12.0308 468.514C18.4444 474.921 27.139 478.52 36.2045 478.52H85.1644C122 301.204 239.902 107.818 390.267 3Z",
    fill: "url(#paint0_linear_3233_1084)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M469.938 480.054H35.9822C26.4453 480.054 17.2985 476.268 10.5515 469.527C3.80456 462.787 0.00942384 453.644 0 444.107V36.9247C0.00942384 27.3878 3.80456 18.2447 10.5515 11.5044C17.2985 4.76413 26.4453 0.978023 35.9822 0.978027H470.116C479.652 0.978023 488.799 4.76413 495.546 11.5044C502.293 18.2447 506.088 27.3878 506.098 36.9247V444.107C506.093 448.844 505.153 453.534 503.332 457.907C501.51 462.28 498.843 466.25 495.484 469.59C492.124 472.93 488.138 475.574 483.754 477.369C479.37 479.165 474.675 480.077 469.938 480.054ZM35.9822 4.53358C27.3883 4.53358 19.1458 7.94509 13.0657 14.0186C6.98552 20.0921 3.56498 28.3308 3.55556 36.9247V444.107C3.56498 452.701 6.98552 460.94 13.0657 467.013C19.1458 473.087 27.3883 476.498 35.9822 476.498H470.116C478.71 476.498 486.952 473.087 493.032 467.013C499.112 460.94 502.533 452.701 502.542 444.107V36.9247C502.533 28.3308 499.112 20.0921 493.032 14.0186C486.952 7.94509 478.71 4.53358 470.116 4.53358H35.9822Z",
    fill: "url(#paint1_linear_3233_1084)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3233_1084",
    x1: 379.138,
    y1: 265.151,
    x2: -10.6578,
    y2: 208.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6DDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163661,
    stopColor: "#B1DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401221,
    stopColor: "#A3D4E5",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497247,
    stopColor: "#9DD2E4",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73286,
    stopColor: "#9BD1E4",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841463,
    stopColor: "#99D1E3",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#98CFE3",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90CCE4",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3233_1084",
    x1: -0.177778,
    y1: 240.516,
    x2: 505.92,
    y2: 240.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3233_1084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 507,
    height: 481,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueGlass);
export default __webpack_public_path__ + "static/media/blueGlass.6340b8b2b8b4e58c181b65e555a2c032.svg";
export { ForwardRef as ReactComponent };